import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { getPriceLadder } from 'gqlQueries/priceLadder';
import { priceLadderAttributeLevelChartParser, priceLadderAttributeLevelTableParser } from 'parser/priceLadderParser';
const errorMessage: string = 'Something went wrong!';

function useFetchPriceLadder({ setSelectedAttributeItem, subTileState }: any) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const rawDataRef = useRef<any[]>([]);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const priceLadderConfig = getConfig('priceLadder', appConfig);

    const [fetchPriceLadder, { data: landscapeData, loading: landscapeDataLoading, error: landscapeDataError }] =
        useLazyQuery(getPriceLadder, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPriceLadderAttributeLevelData } = payload;
            if (
                getPriceLadderAttributeLevelData &&
                getPriceLadderAttributeLevelData?.values?.length === 0 &&
                getPriceLadderAttributeLevelData?.count === 0
            ) {
                onFetchError('No Data');
                return;
            }
            if (
                getPriceLadderAttributeLevelData &&
                'values' in getPriceLadderAttributeLevelData &&
                Array.isArray(getPriceLadderAttributeLevelData.values)
            ) {
                rawDataRef.current?.push(...getPriceLadderAttributeLevelData.values);
                const parsedChartData = priceLadderAttributeLevelChartParser(
                    rawDataRef.current,
                    appConfig,
                    getPriceLadderAttributeLevelData?.ppgName,
                );
                const parsedTableData = priceLadderAttributeLevelTableParser(rawDataRef.current, appConfig);
                //if only product by market is there, by default select the first attribute item
                if (priceLadderConfig?.tileData?.length === 1 && variablesRef.current?.offset === 0) {
                    setSelectedAttributeItem(parsedChartData?.lineData?.[subTileState?.key]?.[0]?.retailer || '');
                }
                setData({ chartData: parsedChartData, tableData: parsedTableData });
                setCount(getPriceLadderAttributeLevelData?.count || 0);
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setCount(0);
        rawDataRef.current = [];
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        count,
        data,
        fetchPriceLadder: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            if (commonConfig.offset === variables.variables?.offset) {
                setCount(0);
                rawDataRef.current = [];
            }
            setData(null);
            setLoading(true);
            setError(null);
            fetchPriceLadder(variables);
            // onFetchComplete(variables);
        },
    };
}

export { useFetchPriceLadder };
